/* DeviceExplorerEntityLmrbComponent.js */

const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const {applyExposureLicenseGate} = require("../../lib/exposureLicenseGate");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");

class DeviceExplorerEntityLmrbComponent extends GameEditor {
    constructor(
        logger,
        di,
        editorLayout,
        userSession,
        DeviceEntity,
        LicenseRestriction,
        OsImageServerEntity,
        storageFactory,
        solutionManager,
        OsUpgradePlanPrefs,
        AutoCapturePrefs,
        ExplorerTemplate,
        SiteEntity,
        ValueMap,
        DataSyncConfig
    ) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._activeOrgId = userSession.activeOrganization.id;
        this._DeviceEntityDef = DeviceEntity;
        this._SiteEntityDef = SiteEntity;
        this._licenseRestriction = LicenseRestriction;
        this._osImageServers = [];
        this._sitePaths = [];
        this._osImageServerEntity = OsImageServerEntity;
        this._solutionManager = solutionManager;
        this._OsUpgradePlanPrefsEntity = OsUpgradePlanPrefs;
        this._isOSMSolutionAvailable = undefined;
        this._isCatalogEnable = undefined;
        this._storageFactory = storageFactory;
        this._openEditorFromUrl = false;
        this._openNetworkDiscoveryFromUrl = false;
        this._filterFromUrl = false;
        this._explorerTemplate = ExplorerTemplate;
        this._autoCapturePrefs = AutoCapturePrefs;
        this._autoCapturePrefsEntity = undefined;
        this._vendorMap = undefined;
        this._typeBaseMap = undefined;
        this._valueMap = ValueMap;
        this._hasSupportedOs = undefined;
        this._dataSyncConfig = DataSyncConfig;
        this._dataSyncConfigEntity = {};
        this._siteFeed = undefined;
        this._updateNameSpaces();

        this._registerDeviceExplorerListeners();

        const superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer._rootElem.classList.add("device-explorer-entity-lmrb");
                if (this.currentSolutionName === "data_explorer") {
                    this.renderer._rootElem.classList.add("data-explorer-lmrb");
                }
                return this.whenGameEditorStorageIsReady().then(() => {
                    const otherParams = _.get(Steve.router.getRouteDetails(), "rd", {});

                    if (otherParams.openEditor && !_.isEmpty(otherParams.selection)) {
                        this._openEditorFromUrl = {
                            open: otherParams.openEditor || false,
                            selectedIds: otherParams.selection,
                        };
                    }
                    if (!_.isEmpty(otherParams.filter) || !_.isUndefined(otherParams.filter)) {
                        this._filterFromUrl = true;
                    }

                    if (otherParams.openNetworkDiscovery && !_.isEmpty(otherParams.selection)) {
                        this._openNetworkDiscoveryFromUrl = {
                            open: otherParams.openNetworkDiscovery || false,
                            selectedIds: otherParams.selection,
                        };
                    }

                    if (this._LMRBLayout.state.bottom.dockletClicked === true) {
                        this._gameEditorData.setData(
                            this._LMRBLayout.state.bottom._state.openedPartId,
                            "currentExplorerView"
                        );
                        this._LMRBLayout.state.bottom.dockletClicked = undefined;
                    }

                    const currentView = this._whereToRedirect();
                    this._switchSolution(currentView);

                    return;
                });
            });
        };
    }

    _whereToRedirect() {
        let currentView = "";
        if (_.get(Steve.router.getRouteDetails(), "exp", false)) {
            const currentViewName = _.get(Steve.router.getRouteDetails(), "exp", "");

            if (this.currentSolutionName === "os_manager") {
                switch (currentViewName) {
                    case "plan":
                        currentView = Registrations.OS_PLAN_EXPLORER_LMRB;
                        break;
                    case "catalog":
                        currentView = Registrations.OS_CATALOG_EXPLORER_LMRB;
                        break;
                    case "iot_device":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                                : Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    case "iotplan":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                                : Registrations.OS_PLAN_EXPLORER_LMRB;
                        break;
                    case "platform":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.PLATFORM_EXPLORER_LMRB
                                : Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    default:
                        currentView = Registrations.OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            } else if (this.currentSolutionName === "config_drift") {
                switch (currentViewName) {
                    case "audit":
                        currentView = Registrations.AUDIT_POLICY_EXPLORER_LMRB;
                        break;
                    default:
                        currentView = Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            } else if (this.currentSolutionName === "data_explorer") {
                switch (currentViewName) {
                    case "template":
                        currentView = Registrations.DATA_EXPLORER_LMRB;
                        break;
                    case "iot_device":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                                : Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    default:
                        currentView = Registrations.DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            } else if (this.currentSolutionName === "device_manager") {
                switch (currentViewName) {
                    case "site":
                        currentView = Registrations.SITE_EXPLORER_ENTITY_LMRB;
                        break;
                    case "network_discovery":
                        currentView = Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB;
                        break;
                    case "iot_device":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
                                : Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    default:
                        currentView = Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            }

            // this._gameEditorData.setData(currentView, "currentExplorerView");
            // Steve.router.rollups({app: 'GameConsole', s: 'GameCenter', sln: 'OsManager'});
        }
        return currentView;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _updateNameSpaces(withUpdate) {
        const solutionDefinition = this._solutionManager.getActiveSolution();
        const gameEditorViews = _.get(solutionDefinition, "deviceExplorer.viewNamespaces", []);
        const gameEditorActions = _.get(solutionDefinition, "deviceExplorer.actionNamespaces", []);

        if (this._userSession.authorizedActions.indexOf("dataExplorerExploreData") < 0) {
            gameEditorActions.remove(
                "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Export"
            );
        } else if (
            gameEditorActions.indexOf(
                "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Export"
            ) < 0
        ) {
            gameEditorActions.push(
                "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Export"
            );
        }

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _updateActions(addList = [], removeList = []) {
        let _actions = [].concat(this._registeredActions, addList);
        _actions = _actions.filter((action) => {
            if (removeList.indexOf(action.fullyQualifiedName) >= 0) {
                return false;
            }
            return true;
        });
        this.registerActions(_actions);
    }

    _registerDeviceExplorerListeners() {
        this._unregisterDeviceExplorerListeners();
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );
        this._editorLayout.on(
            "EditorClosed",
            (this._onEditorClosed = this._onEditorClosed.bind(this))
        );
        this._editorLayout.on("ActiveTabChanged", this._onActiveTabChanged.bind(this));

        Steve.router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = _.throttle(this._onRouteInfoChanged.bind(this), 500))
        );

        this._cabinetCmpnt.on(
            "ExplorerChanged",
            (this._onExplorerChanged = this._onExplorerChanged.bind(this))
        );
    }

    _registerSiteFeedListeners() {
        this._onSiteFeedUpdated = _.debounce(this._onSiteFeedUpdated.bind(this), 5000, {
            leading: true,
            trailing: true,
        });
        this._siteFeed.on("EntityPropertiesUpdated", this._onSiteFeedUpdated);
        this._siteFeed.on("EntityAdded", this._onSiteFeedUpdated);
        this._siteFeed.on("EntityRemoved", this._onSiteFeedUpdated);
    }

    _unregisterSiteFeedListeners() {
        this._onSiteFeedUpdated.cancel();
        this._siteFeed.removeListener("EntityPropertiesUpdated", this._onSiteFeedUpdated);
        this._siteFeed.removeListener("EntityAdded", this._onSiteFeedUpdated);
        this._siteFeed.removeListener("EntityRemoved", this._onSiteFeedUpdated);
    }

    _unregisterDeviceExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
        // Make sure this code fires before editorTab close triggers
        if (this._editorLayout) {
            this._editorLayout.removeListener("EditorClosed", this._onEditorClosed);
            this._editorLayout.removeListener("ActiveTabChanged", this._onActiveTabChanged);
        }
        if (Steve.router) {
            Steve.router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
        }
        if (this._cabinetCmpnt) {
            this._cabinetCmpnt.removeListener("ExplorerChanged", this._onExplorerChanged);
        }
    }

    launchNetworkDiscoveryEditor(editorState, launchOpts) {
        const deviceIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = deviceIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    activeOrgId: deviceIds,
                });

                return this._editorLayout
                    .launchEditor(editorState, Registrations.NETWORK_DISCOVERY_EDITOR, launchOpts)
                    .then(() => {
                        this.emit("EditorLaunched", editorState, launchOpts);
                        return Promise.resolve();
                    });
            });
    }

    launchAdhocQueryEditor(editorState, launchOpts) {
        const deviceIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = `adHocQueryEditor-${deviceIds.join("_")}`;
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    activeOrgId: deviceIds,
                });

                return this._editorLayout
                    .launchEditor(editorState, Registrations.ADHOC_QUERY_EDITOR, launchOpts)
                    .then(() => {
                        this.emit("EditorLaunched", editorState, launchOpts);
                        return Promise.resolve();
                    });
            });
    }

    launchDeviceEditor(editorState, launchOpts) {
        const deviceIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = deviceIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        //console.log('launch device editor: ', deviceIds); //22411 - debug
        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    deviceIds: deviceIds,
                });

                return this._editorLayout
                    .launchEditor(editorState, Registrations.DEVICE_INSTANCE_EDITOR, launchOpts)
                    .then(() => {
                        this.emit("EditorLaunched", editorState, launchOpts);
                        return Promise.resolve();
                    });
            });
    }

    launchDataExplorerView(edState, launchOpts) {
        let editorState;
        if (edState === "result") {
            editorState = {
                fqn: Registrations.DEIE_VIEW_RESULT,
            };
        }
        if (!launchOpts.id) {
            this._logger.warn("DeviceExplorer::launchDataExplorerView::Err", {
                error: {errorMsg: "Template id required to open view"},
            });
        }
        const id = launchOpts.id;
        const ids = [id];

        launchOpts = _.assign({}, launchOpts, {
            id,
            ids,
        });

        return this._editorLayout
            .launchEditor(editorState, Registrations.DATA_INSTANCE_EDITOR, launchOpts)
            .then(() => {
                this.emit("EditorLaunched", editorState, launchOpts);
                return Promise.resolve();
            });
    }

    launchAuditEditor(editorState, launchOpts) {
        const policyId = launchOpts.id;
        const policesIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = policesIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    policyId,
                });
                return this._editorLayout.launchEditor(
                    editorState,
                    Registrations.AUDIT_POLICY_EDITOR,
                    launchOpts
                );
            });
    }

    launchDeviceMultiEditor(ids = []) {
        const editorState = {
            fqn: Registrations.DIE_VIEW_MULTIEDIT,
        };
        const launchOpts = {
            ids: ids,
        };

        return this.launchDeviceEditor(editorState, launchOpts);
    }

    updateFilter(filterString) {
        if (_.isEmpty(filterString)) {
            this._reestablishFeed();
        } else {
            this._reestablishFeed(filterString);
        }
    }

    generateHash(stringToHash) {
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToHash);

        return window.crypto.subtle.digest("SHA-256", data).then(hexString);

        function hexString(buffer) {
            const byteArray = new Uint8Array(buffer);
            const hexCodes = [...byteArray].map((value) => {
                const hexCode = Number(value).toString(16);
                return hexCode.padStart(2, "0");
            });
            return hexCodes.join("");
        }
    }

    onGridColumnUpdated() {
        this.runQuickConfirmationActionWorkflow(
            {
                message: "Column definitions have been changed. Do you want to refresh the page?",
                title: "Update Confirmation Check",
                confirmDetails: {
                    text: "Yes",
                    type: "text",
                },
            },
            (this.onGridUpdateAction = this.onGridUpdateAction.bind(this))
        );
    }

    onGridUpdateAction() {
        return this.renderer.render();
    }

    whenInitialized() {
        return Promise.resolve()
            .then(() => {
                this._activeOrgId = this._userSession.activeOrganization.id;
                return this.getSupportedOs(this._activeOrgId);
            })
            .then(async () => {
                if (this.isDataConfigWriteAvailable) {
                    const serviceNowConfig = await this._dataSyncConfig.loadProviderConfig(
                        this._activeOrgId,
                        "serviceNow",
                        "cmdb"
                    );

                    const netBoxConfig = await this._dataSyncConfig.loadProviderConfig(
                        this._activeOrgId,
                        "netBox",
                        "cmdb"
                    );
                    const xDomeConfig = await this._dataSyncConfig.loadProviderConfig(
                        this._activeOrgId,
                        "claroty",
                        "xdome"
                    );
                    return Promise.resolve({
                        serviceNow: serviceNowConfig,
                        netBox: netBoxConfig,
                        xDome: xDomeConfig,
                    });
                }
                return Promise.resolve({});
            })
            .then((result) => {
                this._dataSyncConfigEntity = result;
                return this._explorerTemplate.loadAscendExplorerTemplates(this._activeOrgId);
            })
            .then((templates) => {
                const isDataSyncEnabledInSettings =
                    (_.hasIn(this._dataSyncConfigEntity, "serviceNow.getEnabled") &&
                        this._dataSyncConfigEntity.serviceNow.getEnabled()) ||
                    (_.hasIn(this._dataSyncConfigEntity, "netBox.getEnabled") &&
                        this._dataSyncConfigEntity.netBox.getEnabled()) ||
                    (_.hasIn(this._dataSyncConfigEntity, "xDome.getEnabled") &&
                        this._dataSyncConfigEntity.xDome.getEnabled());

                /* if (!templates || templates.length === 0) {
                    this._updateActions(
                        [],
                        [
                            "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Export",
                        ]
                    );
                }
                */

                if (!Steve.controlAppNav.xDomeEnabled) {
                    this.hideBarView(Registrations.OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.IOT_OS_PLAN_EXPLORER_LMRB
                    );

                    this.hideBarView(Registrations.DEVICE_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER);
                    this._LMRBLayout.state.bottom.removePart(Registrations.PLATFORM_EXPLORER_LMRB);

                    this.hideBarView(Registrations.DEVICE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER);

                    switch (this.currentSolutionName) {
                        case "device_manager":
                            this._LMRBLayout.state.bottom.removePart(
                                Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
                            );
                            break;
                        case "data_explorer":
                            this._LMRBLayout.state.bottom.removePart(
                                Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                            );
                            break;
                        case "os_manager":
                            this._LMRBLayout.state.bottom.removePart(
                                Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
                            );
                            break;
                        default:
                            break;
                    }
                }

                if (!this.isBackupActionAvailable || !this._hasSupportedOs) {
                    this.hideBarAction(Registrations.DEVICE_EXPLORER_ACTION_BACKUP);
                }
                if (!this.isRestoreActionAvailable || !this._hasSupportedOs) {
                    this.hideBarAction(Registrations.DEVICE_EXPLORER_ACTION_RESTORE);
                }
                if (!this.isDataSyncActionAvailable || !isDataSyncEnabledInSettings) {
                    this.hideBarAction(Registrations.DEVICE_EXPLORER_ACTION_LINK_AND_SYNC);
                }
                if (!this.hasSupportDataRun || !this.hasDeviceSupportDataRead) {
                    this.hideBarAction(Registrations.DEVICE_EXPLORER_ACTION_UPDATE_CISCO);
                }

                // Deliberately NOT returned into this chain. The chain has no catch of its
                // own, so linking a license lookup into it would mean a rejected lookup
                // aborts everything after this point — including the gate itself, leaving
                // Qualify CVE Exposure visible. Fired alongside instead; it resolves on its
                // own and hides the action fail-closed if the license cannot be read.
                applyExposureLicenseGate({
                    licenseRestriction: this._licenseRestriction,
                    logger: this._logger,
                    hide: () =>
                        this.hideBarAction(Registrations.DEVICE_EXPLORER_ACTION_QUALIFY_CVES),
                });

                return this._autoCapturePrefs.loadAscendAutoCapturePrefs(this._activeOrgId, {});
            })
            .then((autoCapturePrefsEntity) => {
                this._autoCapturePrefsEntity = autoCapturePrefsEntity;
                return this._OsUpgradePlanPrefsEntity.loadPrefs(this._activeOrgId);
            })
            .then((OsUpgradePlanPrefs) => {
                this._isCatalogEnable = _.get(OsUpgradePlanPrefs, "enableCatalogs");
                if (!this._isCatalogEnable) {
                    this.hideBarView(Registrations.DEVICE_EXPLORER_SWITCH_TO_OS_CATALOG);
                    this._LMRBLayout.state.bottom.removePart(
                        Registrations.OS_CATALOG_EXPLORER_LMRB
                    );
                } else {
                    const nonActivePartsIds =
                        this._LMRBLayout.state.bottom.getNonActiveAvailablePartsIds();

                    if (
                        nonActivePartsIds.find(
                            (partId) => partId === Registrations.OS_CATALOG_EXPLORER_LMRB
                        )
                    ) {
                        this._LMRBLayout.state.bottom.addPart(
                            Registrations.OS_CATALOG_EXPLORER_LMRB,
                            Registrations.OS_CATALOG_EXPLORER_LMRB
                        );
                    }
                }
                return Promise.resolve();
            })
            .then(() => this._licenseRestriction.whenLicenseFeedIsReady())
            .then(() => this._getVendorMapDynamic())
            .then(() => this._getTypeBaseMapDynamic())
            .then(() => {
                this.isOSMSolutionAvailable = this._licenseRestriction.checkLicense("OSM");
                if (this._isOSMSolutionAvailable === true) {
                    return this._osImageServerEntity.loadAscendOsImageServers(
                        this._userSession.activeOrganization.id,
                        {},
                        {
                            id: true,
                            name: true,
                            identifier: true,
                            isMain: true,
                        }
                    );
                } else {
                    return Promise.resolve([]);
                }
            })
            .then((osImageServers) => {
                this._osImageServers = osImageServers;
            })
            .then(() => this._startSiteFeed())
            .then(() => this._loadAllSites());
    }

    _startSiteFeed() {
        this._siteFeed = this._SiteEntityDef.startSitesFeed(
            this._userSession.activeOrganization.id,
            {},
            {path: true, name: true, locationType: true},
            {updatedOn: -1}
        );

        return this._siteFeed.whenInitialized().then((sitesFeed) => {
            this._siteFeed = sitesFeed;
            this._registerSiteFeedListeners();
        });
    }

    _stopSiteFeed() {
        if (!this._siteFeed) {
            return Promise.resolve();
        }
        this._unregisterSiteFeedListeners();
        return this._siteFeed.shutdown().then(() => {
            this._siteFeed = undefined;
        });
    }

    /**
     * On a first visit, reopen previously opened solution
     */
    _switchSolution(view = "") {
        if (
            this.currentSolutionName === "config_drift" ||
            this.currentSolutionName === "os_manager" ||
            this.currentSolutionName === "data_explorer" ||
            this.currentSolutionName === "device_manager"
        ) {
            let currentExplorerView = this._gameEditorData.getData("currentExplorerView");
            if (!_.isEmpty(view)) {
                currentExplorerView = view;
            }
            const isXdomeEnabled = Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled;
            this._gameEditorData.setData(currentExplorerView, "currentExplorerViewTemp");
            if (
                currentExplorerView &&
                currentExplorerView === Registrations.AUDIT_POLICY_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.AUDIT_POLICY_EXPLORER_LMRB);
                /*} else if (currentExplorerView && currentExplorerView === Registrations.OS_CATALOG_EXPLORER_LMRB && this._isCatalogEnable) {
                this.openLMRBExplorer(Registrations.OS_CATALOG_EXPLORER_LMRB);*/
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.DATA_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.DATA_EXPLORER_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.SITE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.SITE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.OS_PLAN_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.OS_PLAN_EXPLORER_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.IOT_OS_PLAN_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.IOT_OS_PLAN_EXPLORER_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.PLATFORM_EXPLORER_LMRB &&
                isXdomeEnabled
            ) {
                this.openLMRBExplorer(Registrations.PLATFORM_EXPLORER_LMRB);
            } else {
                this._cabinetCmpnt.selectView(Registrations.DEVICE_EXPLORER_VIEW_GRID);
            }
            return;
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    get isOSMSolutionAvailable() {
        return this._isOSMSolutionAvailable;
    }

    set isOSMSolutionAvailable(isAvailable) {
        this._isOSMSolutionAvailable = isAvailable;
    }

    get osImageServers() {
        return this._osImageServers;
    }

    get sitePaths() {
        return this._sitePaths;
    }

    get isBackupActionAvailable() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceBackupRun") > -1;
    }

    get hasRestorePerms() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceRestoreRun") > -1;
    }

    get hasGroupRestorePerms() {
        // replace with group restore permission
        return (
            _.get(this._userSession, "authorizedActions").indexOf("multipleDeviceRestoreRun") > -1
        );
    }

    get isRestoreActionAvailable() {
        return this.hasGroupRestorePerms;
    }

    get hasSupportDataRun() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceSupportDataRun") > -1;
    }

    get hasDeviceSupportDataRead() {
        return _.get(this._userSession, "authorizedActions").indexOf("deviceSupportDataRead") > -1;
    }

    get isDataSyncActionAvailable() {
        return _.get(this._userSession, "authorizedActions").indexOf("dataSyncRun") > -1;
    }

    get isDataConfigWriteAvailable() {
        return _.get(this._userSession, "authorizedActions").indexOf("dataConfigWrite") > -1;
    }

    /** @deprecated use osImageServerMain */
    get osImageServerMaster() {
        return this.osImageServerMain;
    }
    get osImageServerMain() {
        return this.osImageServerList.find((osImageServer) => osImageServer.isMain);
    }

    get isOsUpgradeAutoCaptured() {
        return _.get(this._autoCapturePrefsEntity.getOwnOrgEvents(), "deviceOsUpgrade", false);
    }

    get isOsTransferAutoCaptured() {
        return _.get(this._autoCapturePrefsEntity.getOwnOrgEvents(), "deviceOsTransfer", false);
    }

    getSupportedOs(orgId) {
        return this._valueMap.loadVendorOsMapEntity(orgId).then((vendorOsMapEntity) => {
            const backupRestoreVendorOsMap =
                (vendorOsMapEntity &&
                    vendorOsMapEntity.filterVendorOsMapByOsProp(
                        "supportedFeatures.backupAndRestore",
                        true
                    )) ||
                {};
            const hasSupportedOs = Object.values(backupRestoreVendorOsMap).some((item) => {
                return !!item.os;
            });
            this._hasSupportedOs = hasSupportedOs;

            const supportedOSs = Object.values(backupRestoreVendorOsMap).reduce((acc, item) => {
                for (const os of Object.values(item.os)) {
                    acc.push(os.displayName);
                }
                return acc;
            }, []);
            this._supportedOsList = supportedOSs;
            return Promise.resolve();
        });
    }

    shutdown() {
        this._unregisterDeviceExplorerListeners();
        const shutdowns = [
            //_.invoke(this._statusBar, "shutdown")
            this._stopSiteFeed(),
        ];
        return Promise.all(shutdowns).then(
            () => {
                this._userSession = undefined;
                this._editorLayout = undefined;
                this._DeviceEntityDef = undefined;
                this._SiteEntityDef = undefined;
                this._OsUpgradePlanPrefsEntity = undefined;
                this._licenseRestriction = undefined;
                this._isCatalogEnable = undefined;
                this._filterFromUrl = undefined;
                this._autoCapturePrefs = undefined;
                this._vendorMap = undefined;
                this._typeBaseMap = undefined;
                this._autoCapturePrefsEntity = undefined;
                this._sitePaths = undefined;
                this._osImageServers = undefined;
                this._valueMap = undefined;
                this._hasSupportedOs = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "DeviceExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/
    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     newActiveSolution.lmrbNamespaces &&
        //     newActiveSolution.lmrbNamespaces.includes(Registrations.DEVICE_EXPLORER_ENTITY_LMRB)
        // ) {
        //     this._updateNameSpaces(true);
        //     this.renderer.render();
        // } else {
        this.shutdown();
        // }
    }

    _onOrganizationChange(newOrg, oldOrg) {
        this.emit("OrganizationChanged");
        this._unregisterDeviceExplorerListeners();
        if (!_.isUndefined(newOrg) && !_.isUndefined(oldOrg) && newOrg.id !== oldOrg.id) {
            this._updateNameSpaces(true);
            this.renderer.render().then(() => {
                this._registerDeviceExplorerListeners();
            });
        }
    }

    _onEditorClosed(tabId, editorParams) {
        this.emit("EditorClosed", tabId, editorParams);
    }

    _onActiveTabChanged(tabId, editorParams) {
        this.emit("ActiveTabChanged", tabId, editorParams);
    }

    _onRouteInfoChanged() {
        if (event && event.oldURL !== event.newURL) {
            const currentView = this._whereToRedirect();
            if (
                currentView &&
                this._gameEditorData.getData("currentExplorerViewTemp") !== currentView
            ) {
                this._gameEditorData.setData(currentView, "currentExplorerViewTemp");
                this._gameEditorData.setData(currentView, "currentExplorerView");
                this._cabinetCmpnt.emit("ExplorerChanged");
                this.openLMRBExplorer(currentView);
            }
        }
    }

    _onExplorerChanged() {
        this.shutdown();
    }

    _onSitePanelVisibilityChanged(isVisible) {
        if (isVisible) {
            if (this._siteFeed) {
                this._onSiteFeedUpdated();
            } else {
                this._startSiteFeed().then(() => this._onSiteFeedUpdated());
            }
        } else {
            this._stopSiteFeed();
        }
    }

    _onSiteFeedUpdated() {
        this._loadAllSites().then(() => {
            this.emit("RegenerateTreeData");
        });
    }

    _loadAllSites() {
        this._sitePaths = Object.values(this._siteFeed.cache);
        return Promise.resolve();
    }

    async _getVendorMapDynamic() {
        this._vendorMap = await this._DeviceEntityDef.loadAndMergeVendorMap(this._activeOrgId);
        return Promise.resolve();
    }

    async _getTypeBaseMapDynamic() {
        this._typeBaseMap = await this._DeviceEntityDef.loadAndMergeTypeBaseMap(this._activeOrgId);
        return Promise.resolve();
    }
}

module.exports = DeviceExplorerEntityLmrbComponent;

DeviceExplorerEntityLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.entities.Device",
    "$teve.licenseRestriction",
    "$teve.entities.OsImageServer",
    "$teve.storageFactory",
    "$teve.solutionsManager",
    "$teve.entities.OsUpgradePlanPrefs",
    "$teve.entities.AutoCapturePrefs",
    "$teve.entities.ExplorerTemplate",
    "$teve.entities.Site",
    "$teve.entities.ValueMap",
    "$teve.entities.DataSyncConfig",
];
DeviceExplorerEntityLmrbComponent.$supportedQuadrants = ["bottom"];
DeviceExplorerEntityLmrbComponent.$defaultQuadrants = ["bottom"];
DeviceExplorerEntityLmrbComponent.$iconRepoName = "configdrift.devices";
DeviceExplorerEntityLmrbComponent.$openedByDefault = true;
DeviceExplorerEntityLmrbComponent.$displayName = "Device Explorer";
